import { Dispatch, SetStateAction, useState } from 'react';
import { QueryKey, UseQueryResult, useQuery } from 'react-query';

import { GetEmployees } from '@pimm/services/lib/sms-workforce/services';
import { GetEmployeesQueryParams } from '@pimm/services/lib/sms-workforce';

export type GetEmployeesParams = GetEmployeesQueryParams;

export const useGetEmployees = (props?: {
  queryKey?: string;
  query?: GetEmployeesParams;
}): [UseQueryResult<Awaited<ReturnType<typeof GetEmployees>>>, Dispatch<SetStateAction<GetEmployeesParams>>] => {
  const [query, setQuery] = useState<GetEmployeesParams>({ ...props?.query });

  const schedules = useQuery({
    cacheTime: 0,
    enabled: !!query?.siteId,
    queryKey: [props?.queryKey ?? 'GetEmployees', query] as [QueryKey, GetEmployeesParams],
    queryFn: ({ queryKey: [key, params] }) => {
      return GetEmployees({
        siteId: params.siteId,
      });
    },
  });

  return [schedules, setQuery];
};
